import styled from '@emotion/styled'

import { minDeviceWidth, maxDeviceWidth } from '../../../utils/mixins'
import { Typo50darkSaturatedOrangeDB } from '../../../themes/Fonts/Din2014'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  ${maxDeviceWidth(1023)} {
    margin-top: 20px;
  }
  ${maxDeviceWidth(768)} {
    margin-top: 20px;
    margin-bottom: 20px;
  }
`
export const ArticlesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 60px;
  ${maxDeviceWidth(767)} {
    font-size: 20px;
  }
  ${minDeviceWidth(768)} {
    font-size: 24px;
  }
  ${maxDeviceWidth(500)} {
    font-size: 18px;
  }
`

export const MediaHousesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${maxDeviceWidth(767)} {
    font-size: 20px;
  }
  ${maxDeviceWidth(500)} {
    font-size: 18px;
  }
  ${minDeviceWidth(768)} {
    font-size: 24px;
  }
`

export const ArticlesCount = styled(Typo50darkSaturatedOrangeDB)`
  margin-bottom: 0px;
  font-weight: 700;
  ${maxDeviceWidth(1023)} {
    font-size: 40px;
  }
`
export const ArticlesText = styled.p`
  margin-bottom: 0px;
  font-weight: 700;
`

export const MediaHousesCount = styled(Typo50darkSaturatedOrangeDB)`
  margin-bottom: 0px;
  font-weight: 700;
  ${maxDeviceWidth(1023)} {
    font-size: 40px;
  }
`

export const MediaHousesText = styled.p`
  margin-bottom: 0px;
  font-weight: 700;
`



// WEBPACK FOOTER //
// ./src/components/IbcNews/StatsContainer/styledComponents.js